import type { FonotekaPack } from '@/api/client';
import { splitFileNameStemAndSuffix } from '@/components/ProjectFilesPopover/projectFilesPopoverUtils';
import type { GlobalAudioTrack } from './globalAudioState';

/** Flat playlist: packs then tracks in catalog order (already alphabetical from API/cache). */
export function buildFonotekaPlaylist(packs: FonotekaPack[]): GlobalAudioTrack[] {
  const out: GlobalAudioTrack[] = [];
  for (const pack of packs) {
    for (const track of pack.tracks) {
      const src = track.file_url?.trim() ?? '';
      if (!src) continue;
      const { stem } = splitFileNameStemAndSuffix(track.file_name);
      out.push({
        instanceId: track.id,
        src,
        title: stem || track.file_name,
        source: 'fonoteka',
        packId: pack.id,
      });
    }
  }
  return out;
}

/** Сосед трека в списке; трека в списке нет или он крайний — null */
export function neighborInPlaylist(
  list: readonly GlobalAudioTrack[],
  instanceId: string,
  direction: 1 | -1,
): GlobalAudioTrack | null {
  const idx = list.findIndex((item) => item.instanceId === instanceId);
  if (idx < 0) return null;
  return list[idx + direction] ?? null;
}

export function playlistIndex(list: readonly GlobalAudioTrack[], instanceId: string): { index: number; length: number } {
  return { index: list.findIndex((item) => item.instanceId === instanceId), length: list.length };
}

export function neighborFonotekaTrack(
  packs: FonotekaPack[] | undefined,
  instanceId: string,
  direction: 1 | -1,
): GlobalAudioTrack | null {
  if (!packs?.length) return null;
  return neighborInPlaylist(buildFonotekaPlaylist(packs), instanceId, direction);
}

export function fonotekaPlaylistIndex(
  packs: FonotekaPack[] | undefined,
  instanceId: string,
): { index: number; length: number } {
  if (!packs?.length) return { index: -1, length: 0 };
  return playlistIndex(buildFonotekaPlaylist(packs), instanceId);
}
